import $ from 'jquery';
import _ from 'underscore';
import render from '../render';

const modalCheckboxHtml = require("./html/modalCheckbox.html");
const modalPillUnitsHtml = require("./html/modalPillUnits.html");


export function modalRenderCheckbox(data, type, row){
  return render(
    modalCheckboxHtml,
    {
      value: data
    }
  )
}

//Populate Available Unit Pills
export function modalRenderPillUnits(data, type, row){
  let pillColor;
  if (data <= 0){
    pillColor = "q-pill-red";
  } else {
    pillColor = "q-pill-white-and-grey";
  }
  return render(
    modalPillUnitsHtml,
    {
      value: data,
      pillClassQty: pillColor
    }
  )
}

export function getCheckedRowsFromDataTable(dt, selector){
  const checkedRows = _($(dt.api().rows().nodes()).toArray()).filter(function(tr){
    return !!$(tr).find(`${selector}:checked`).length;
  })
  return $(checkedRows);
}


export function getCheckedFromDataTable(dt, selector){
  // We are not actually searching the dom for these elements using $,
  // all we are doing is wrapping them in a jquery object because
  // they are pre-selected
  return $(dt.api().rows().nodes()).find(`${selector}:checked`);
}

export function countCheckedFromDataTable(dt, selector){
  return getCheckedFromDataTable(dt, selector).length;
}

//hybrid function of checking both if search was performed with total seen checked AND general checked boxes
export function handleTotalChecked(addProductsModal, modalOrderTable, modalCheckboxSelector) {
  const totalChecked = countCheckedFromDataTable(modalOrderTable, modalCheckboxSelector);
  // console.log(getCheckedRowsFromDataTable(modalOrderTable, modalCheckboxSelector));
  // console.log(totalChecked);
  // $('.order-wizard-modal-total-checked').html(totalChecked);
  updateTotalCheckedArea(addProductsModal, totalChecked);
}
//Time to mutate some HTML and populate the modal with the number of checked boxes!
export function updateTotalCheckedArea(addProductsModal, totalChecked) {
  let checkedContent = "";
  if(totalChecked == 1){
    checkedContent = `1 Product Selected`;
  }
  else{
    checkedContent = `${totalChecked} Products Selected`;
  }
  addProductsModal.find('.order-wizard-modal-total-checked').html(checkedContent);
}



// WEBPACK FOOTER //
// ./src/utilities/productsModalUtilities/index.js